import { useState } from "react";

const GAME_PASSWORD = "bunchh2026";

// All questions with type tags
const allQuestions = [
  // BASICS
  { type: "question", text: "Which fictional character do you most relate to?" },
  { type: "question", text: "What's one thing that instantly makes a weekend feel perfect to you?" },
  { type: "question", text: "If someone lived your life for a day, what should they be prepared for?" },
  { type: "question", text: "What's something super basic that brings you a weird amount of joy?" },
  { type: "question", text: "What's a book, movie, or show you'd recommend to everyone here?" },
  { type: "question", text: "What's your relationship or friendship dealbreaker?" },
  { type: "question", text: "What's one hobby you'd love to share with your partner?" },
  { type: "question", text: "If we became friends after tonight, what would you want us to do together next?" },
  { type: "question", text: "What's something you've always wanted to try but haven't yet?" },
  { type: "question", text: "What's your 'my brain needs a break' activity?" },
  { type: "question", text: "A new thing you tried this year and how it went…" },
  { type: "question", text: "If you could have dinner with any three people, living or dead, who would you pick?" },
  { type: "question", text: "What's your 'I will never shut up about this' topic?" },
  { type: "question", text: "What's a phrase or word you overuse but can't stop saying?" },
  { type: "question", text: "What's a food you irrationally hate?" },
  { type: "question", text: "What's a trend you just don't understand?" },
  { type: "question", text: "What's a popular movie or show everyone loves that you just don't get?" },
  { type: "question", text: "What's the craziest thing you've done after a breakup?" },
  { type: "question", text: "What's your most romantic moment?" },
  { type: "question", text: "What's something you used to believe about love that you don't anymore?" },
  { type: "question", text: "What's your 'type' of a person? Make it oddly specific." },
  { type: "question", text: "What's the most spontaneous thing you have ever done?" },
  { type: "question", text: "What's a random life lesson you learned the hard way?" },
  { type: "question", text: "What's one thing you overthink way more than you should?" },
  { type: "question", text: "A compliment you still remember…" },
  { type: "question", text: "What's one thing you wish more people knew about you?" },
  { type: "question", text: "What's your low-effort way to feel like you've got your life together?" },
  { type: "question", text: "If you had the 'anywhere door', where would you run off to?" },
  { type: "question", text: "As a kid, what did you dream of becoming?" },
  { type: "question", text: "A small thing that instantly improves your mood is…" },
  { type: "question", text: "What's a life skill you should have by now but absolutely do not?" },
  { type: "question", text: "What's something you can't resist buying — even if you don't need it?" },
  { type: "question", text: "If you were a drink, what would the ingredients be?" },
  { type: "question", text: "What's one opinion you never change your mind about?" },
  { type: "question", text: "If someone judged you by your music playlists, what would they assume?" },

  // DARES
  { type: "dare", text: "Show the weirdest photo in your camera roll. No context allowed." },
  { type: "dare", text: "Compliment someone at the table — make it specific." },
  { type: "dare", text: "Share 2 truths and 1 lie. Let the table guess." },
  { type: "dare", text: "Show the table your ChatGPT history and answer a question about it." },
  { type: "dare", text: "Call the server and make eye contact for 10 seconds without saying a word." },
  { type: "dare", text: "Let any player at the table ask you one personal question — answer honestly." },
  { type: "dare", text: "Say the alphabet backward as fast as you can." },
  { type: "dare", text: "Teach the group a word in a language you know (even if you only know one)." },
  { type: "dare", text: "Send a voice note to your last WhatsApp chat saying 'I've made a huge mistake.'" },
  { type: "dare", text: "Try to guess someone's favourite food — if you're wrong, you owe them a compliment." },

  // PLOT TWISTS
  { type: "twist", text: "You must now speak in a different language for the next 2 rounds." },
  { type: "twist", text: "From now on, every sentence you speak must start with a word the group decides." },
  { type: "twist", text: "Give someone a new nickname based on tonight. That's what they'll be called for the rest of the night." },
  { type: "twist", text: "Everyone is lying. For the next 3 minutes, no one is allowed to tell the truth — about anything. Once time ends, each person must guess the biggest lie they heard." },
  { type: "twist", text: "Everyone must look at the person to their right and predict the kind of friend they'll become. ('You feel like my random 2am deep talk friend' or 'the one who always sends reels first')" },
];

// Shuffle helper
function shuffle(arr) {
  const a = [...arr];
  for (let i = a.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [a[i], a[j]] = [a[j], a[i]];
  }
  return a;
}

// Split shuffled questions into 3 roughly equal rounds
function buildRounds() {
  const shuffled = shuffle(allQuestions);
  const size = Math.ceil(shuffled.length / 3);
  return [
    { name: "Round 01", theme: "Get Talking", prompts: shuffled.slice(0, size) },
    { name: "Round 02", theme: "Get Honest", prompts: shuffled.slice(size, size * 2) },
    { name: "Round 03", theme: "Get Real", prompts: shuffled.slice(size * 2) },
  ];
}

const TYPE_CONFIG = {
  question: { label: "Question", color: "#8B2A0F", bg: "#FAF0EC" },
  dare:     { label: "Dare",     color: "#1C5C3A", bg: "#EDF5F0" },
  twist:    { label: "Plot Twist", color: "#3A3270", bg: "#EEEDF8" },
};

const rules = [
  "A question appears on screen. Read it out loud to the table.",
  "Go around — everyone answers before you move to the next one. Decide amongst yourselves who starts.",
  "Be honest. The more real you are, the better this gets.",
  "Put your phone face down while someone's talking.",
  "Nothing shared here leaves this table.",
];

export default function TableTalk() {
  const [phase, setPhase] = useState("password");
  const [passwordInput, setPasswordInput] = useState("");
  const [passwordError, setPasswordError] = useState(false);
  const [shake, setShake] = useState(false);
  const [rounds] = useState(() => buildRounds());
  const [roundIndex, setRoundIndex] = useState(0);
  const [promptIndex, setPromptIndex] = useState(0);
  const [fading, setFading] = useState(false);

  const currentRound = rounds[roundIndex];
  const currentCard = currentRound?.prompts[promptIndex];
  const typeConfig = currentCard ? TYPE_CONFIG[currentCard.type] : TYPE_CONFIG.question;

  const isLastPrompt =
    roundIndex === rounds.length - 1 &&
    promptIndex === currentRound.prompts.length - 1;

  const progressTotal = rounds.reduce((a, r) => a + r.prompts.length, 0);
  const progressCurrent =
    rounds.slice(0, roundIndex).reduce((a, r) => a + r.prompts.length, 0) +
    promptIndex + 1;

  const handlePassword = () => {
    if (passwordInput.toLowerCase().trim() === GAME_PASSWORD) {
      setPhase("rules");
    } else {
      setPasswordError(true);
      setShake(true);
      setTimeout(() => setShake(false), 500);
      setTimeout(() => setPasswordError(false), 2500);
    }
  };

  const handleNext = () => {
    if (fading) return;
    setFading(true);
    setTimeout(() => {
      if (promptIndex < currentRound.prompts.length - 1) {
        setPromptIndex(promptIndex + 1);
      } else if (roundIndex < rounds.length - 1) {
        setRoundIndex(roundIndex + 1);
        setPromptIndex(0);
      } else {
        setPhase("end");
      }
      setFading(false);
    }, 350);
  };

  return (
    <div style={{ fontFamily: "sans-serif", minHeight: "100vh" }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Fraunces:ital,wght@0,300;0,400;0,600;1,300;1,400&family=DM+Sans:wght@300;400;500&display=swap');

        *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }

        :root {
          --cream: #F2EDE6;
          --cream-dark: #E4DDD4;
          --text: #1C1C1A;
          --muted: #8A8070;
          --terra: #8B2A0F;
          --terra-soft: #C4856A;
          --white: #FFFFFF;
        }

        .tt-page {
          min-height: 100vh;
          background: var(--cream);
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          padding: 32px 20px;
        }

        .tt-header { text-align: center; margin-bottom: 36px; }

        .tt-wordmark {
          font-family: 'Fraunces', serif;
          font-size: 20px;
          font-weight: 400;
          color: var(--text);
          letter-spacing: -0.01em;
        }
        .tt-wordmark-dot { color: var(--terra); }

        .tt-tagline {
          font-family: 'DM Sans', sans-serif;
          font-size: 11px;
          font-weight: 400;
          letter-spacing: 0.22em;
          text-transform: uppercase;
          color: var(--muted);
          margin-top: 3px;
        }

        .tt-card {
          width: 100%;
          max-width: 500px;
          background: var(--white);
          border-radius: 20px;
          padding: 48px 44px;
          box-shadow: 0 2px 32px rgba(28,28,26,0.07);
        }

        .tt-eyebrow {
          font-family: 'DM Sans', sans-serif;
          font-size: 11px;
          font-weight: 500;
          letter-spacing: 0.2em;
          text-transform: uppercase;
          color: var(--terra);
          margin-bottom: 14px;
        }

        .tt-title {
          font-family: 'Fraunces', serif;
          font-size: 36px;
          font-weight: 400;
          line-height: 1.1;
          color: var(--text);
          margin-bottom: 10px;
          letter-spacing: -0.02em;
        }

        .tt-body {
          font-family: 'DM Sans', sans-serif;
          font-size: 14px;
          font-weight: 300;
          color: var(--muted);
          line-height: 1.65;
          margin-bottom: 32px;
        }

        .tt-input-wrap { margin-bottom: 4px; }

        .tt-input {
          width: 100%;
          padding: 14px 18px;
          font-family: 'DM Sans', sans-serif;
          font-size: 15px;
          background: var(--cream);
          border: 1.5px solid var(--cream-dark);
          border-radius: 10px;
          outline: none;
          color: var(--text);
          transition: border-color 0.2s;
          letter-spacing: 0.1em;
        }
        .tt-input:focus { border-color: var(--terra); }
        .tt-input.err { border-color: #B03020; background: #FEF5F3; }

        .tt-err-text {
          font-family: 'DM Sans', sans-serif;
          font-size: 13px;
          color: #B03020;
          margin-top: 8px;
        }

        @keyframes shake {
          0%,100% { transform: translateX(0); }
          20% { transform: translateX(-9px); }
          40% { transform: translateX(9px); }
          60% { transform: translateX(-5px); }
          80% { transform: translateX(5px); }
        }
        .shake { animation: shake 0.45s ease; }

        .tt-btn {
          display: block;
          width: 100%;
          padding: 14px 24px;
          font-family: 'DM Sans', sans-serif;
          font-size: 12px;
          font-weight: 500;
          letter-spacing: 0.18em;
          text-transform: uppercase;
          background: var(--terra);
          color: var(--white);
          border: none;
          border-radius: 100px;
          cursor: pointer;
          margin-top: 20px;
          transition: opacity 0.2s, transform 0.15s;
        }
        .tt-btn:hover { opacity: 0.82; transform: translateY(-1px); }
        .tt-btn:active { transform: translateY(0); }
        .tt-btn:disabled { opacity: 0.5; cursor: default; transform: none; }

        .tt-hr { height: 1px; background: var(--cream-dark); margin: 28px 0; }

        .tt-rules { list-style: none; }
        .tt-rule {
          display: flex;
          gap: 14px;
          align-items: flex-start;
          padding: 12px 0;
          border-bottom: 1px solid var(--cream);
        }
        .tt-rule:last-child { border-bottom: none; }
        .tt-rule-n {
          font-family: 'Fraunces', serif;
          font-style: italic;
          font-size: 16px;
          color: var(--terra-soft);
          min-width: 18px;
          padding-top: 1px;
        }
        .tt-rule-t {
          font-family: 'DM Sans', sans-serif;
          font-size: 14px;
          font-weight: 300;
          color: var(--text);
          line-height: 1.55;
        }

        /* GAME */
        .tt-tabs { display: flex; gap: 5px; margin-bottom: 24px; }
        .tt-tab {
          flex: 1;
          height: 2.5px;
          border-radius: 2px;
          background: var(--cream-dark);
          transition: background 0.4s;
        }
        .tt-tab.on { background: var(--terra); }

        .tt-round-row {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 20px;
        }
        .tt-round-label {
          font-family: 'DM Sans', sans-serif;
          font-size: 11px;
          font-weight: 500;
          letter-spacing: 0.2em;
          text-transform: uppercase;
          color: var(--terra);
        }
        .tt-round-theme {
          font-family: 'DM Sans', sans-serif;
          font-size: 12px;
          color: var(--muted);
        }

        .tt-type-badge {
          display: inline-block;
          padding: 4px 12px;
          border-radius: 100px;
          font-family: 'DM Sans', sans-serif;
          font-size: 11px;
          font-weight: 500;
          letter-spacing: 0.12em;
          text-transform: uppercase;
          margin-bottom: 20px;
          transition: all 0.3s ease;
        }

        .tt-prompt-box {
          min-height: 150px;
          display: flex;
          align-items: center;
          margin-bottom: 32px;
          transition: opacity 0.3s ease;
        }
        .tt-prompt-box.fade { opacity: 0; }

        .tt-prompt {
          font-family: 'Fraunces', serif;
          font-size: 26px;
          font-weight: 300;
          line-height: 1.44;
          color: var(--text);
          letter-spacing: -0.01em;
        }

        .tt-prog-bar {
          height: 2px;
          background: var(--cream-dark);
          border-radius: 2px;
          overflow: hidden;
          margin-bottom: 7px;
        }
        .tt-prog-fill {
          height: 100%;
          background: var(--terra);
          border-radius: 2px;
          transition: width 0.4s ease;
        }
        .tt-prog-text {
          font-family: 'DM Sans', sans-serif;
          font-size: 12px;
          color: var(--muted);
          font-weight: 300;
          margin-bottom: 20px;
        }

        /* END */
        .tt-end { text-align: center; padding: 12px 0; }
        .tt-end-glyph {
          font-family: 'Fraunces', serif;
          font-size: 36px;
          color: var(--terra);
          display: block;
          margin-bottom: 20px;
        }
        .tt-end-title {
          font-family: 'Fraunces', serif;
          font-size: 32px;
          font-weight: 400;
          color: var(--text);
          margin-bottom: 14px;
          letter-spacing: -0.02em;
        }
        .tt-end-body {
          font-family: 'DM Sans', sans-serif;
          font-size: 14px;
          font-weight: 300;
          color: var(--muted);
          line-height: 1.75;
          margin-bottom: 36px;
        }

        @keyframes fadeUp {
          from { opacity: 0; transform: translateY(12px); }
          to   { opacity: 1; transform: translateY(0); }
        }
        .up { animation: fadeUp 0.45s ease both; }

        @media (max-width: 560px) {
          .tt-card { padding: 36px 26px; }
          .tt-title { font-size: 28px; }
          .tt-prompt { font-size: 21px; }
        }
      `}</style>

      <div className="tt-page">
        <div className="tt-header">
          <div className="tt-wordmark">Bunchh<span className="tt-wordmark-dot">.</span></div>
          <div className="tt-tagline">Table Talk</div>
        </div>

        <div className="tt-card">

          {phase === "password" && (
            <div className="up">
              <div className="tt-eyebrow">Members Only</div>
              <div className="tt-title">Welcome<br />to the table.</div>
              <div className="tt-body">Enter your event password to begin the conversation.</div>
              <div className={`tt-input-wrap ${shake ? "shake" : ""}`}>
                <input
                  className={`tt-input ${passwordError ? "err" : ""}`}
                  type="password"
                  placeholder="Event password"
                  value={passwordInput}
                  onChange={(e) => setPasswordInput(e.target.value)}
                  onKeyDown={(e) => e.key === "Enter" && handlePassword()}
                  autoFocus
                />
                {passwordError && <div className="tt-err-text">That's not quite right. Try again.</div>}
              </div>
              <button className="tt-btn" onClick={handlePassword}>Enter</button>
            </div>
          )}

          {phase === "rules" && (
            <div className="up">
              <div className="tt-eyebrow">Before We Begin</div>
              <div className="tt-title">Here's how<br />this works.</div>
              <div className="tt-body">Table Talk is a conversation game for the people you just met — or the ones you thought you knew. Three rounds, {progressTotal} cards, no wrong answers. Expect questions, dares, and a few plot twists.</div>
              <div className="tt-hr" />
              <ul className="tt-rules">
                {rules.map((r, i) => (
                  <li className="tt-rule" key={i}>
                    <span className="tt-rule-n">{i + 1}</span>
                    <span className="tt-rule-t">{r}</span>
                  </li>
                ))}
              </ul>
              <button className="tt-btn" onClick={() => setPhase("game")}>Ready when you are →</button>
            </div>
          )}

          {phase === "game" && (
            <div className="up">
              <div className="tt-tabs">
                {rounds.map((_, i) => (
                  <div key={i} className={`tt-tab ${i <= roundIndex ? "on" : ""}`} />
                ))}
              </div>
              <div className="tt-round-row">
                <span className="tt-round-label">{currentRound.name}</span>
                <span className="tt-round-theme">{currentRound.theme}</span>
              </div>

              <div
                className="tt-type-badge"
                style={{
                  color: typeConfig.color,
                  background: typeConfig.bg,
                }}
              >
                {typeConfig.label}
              </div>

              <div className={`tt-prompt-box ${fading ? "fade" : ""}`}>
                <div className="tt-prompt">{currentCard?.text}</div>
              </div>

              <div className="tt-prog-bar">
                <div className="tt-prog-fill" style={{ width: `${(progressCurrent / progressTotal) * 100}%` }} />
              </div>
              <div className="tt-prog-text">{progressCurrent} of {progressTotal} cards</div>
              <button className="tt-btn" onClick={handleNext} disabled={fading}>
                {isLastPrompt ? "Finish" : "Next Card →"}
              </button>
            </div>
          )}

          {phase === "end" && (
            <div className="tt-end up">
              <span className="tt-end-glyph">✦</span>
              <div className="tt-end-title">That's a wrap.</div>
              <div className="tt-end-body">
                Thank you for showing up fully tonight.<br />
                The best conversations don't end here — they continue over the meal, on the way home, and long after.
              </div>
              <button className="tt-btn" onClick={() => {
                setPhase("password");
                setPasswordInput("");
                setRoundIndex(0);
                setPromptIndex(0);
              }}>Play Again</button>
            </div>
          )}

        </div>
      </div>
    </div>
  );
}
